import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

import { TxSelectors } from "src/redux/Tx/selectors";
import { AvailabilitySelectors } from "src/redux/Availability/selectors";
import { TableActions } from "src/redux/Table/actions";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import DatePickerEditor from "src/components/common/AgGrid/DatePicker";
import TruTooltip from "src/components/common/AgGrid/TruTooltip";
import * as Validators from "src/utils/validators";
import {
    RowClassRules,
    CommonColumnDefs,
    getTakeAvailabilityColumnDefs,
} from "./column_defs";
import DeleteRenderer from "src/components/common/AgGrid/DeleteRenderer";
import { REQUEST_STATES } from "src/redux/Tx/constants";

import "src/styles/agGridCustom.scss";
import styles from "./styles.module.scss";
import { AvailabilityActions } from "src/redux/Availability/actions";
import { EXPORT_FORMAT } from "src/components/common/AgGrid/formatters";

const rowsToUpdate = [];
let timerForUpdate = null;

class Table extends PureComponent {
    componentDidUpdate(prevProps) {
        // TODO
        const isSendCancelled =
            prevProps.sendingState === REQUEST_STATES.SENDING &&
            this.props.sendingState === REQUEST_STATES.NONE;
        const isSendDisabled =
            prevProps.isReadyToSubmit && !this.props.isReadyToSubmit;

        if (isSendCancelled || isSendDisabled) {
            this.gridApi && this.gridApi.refreshCells();
        }
    }

    componentWillUnmount() {
        this.gridApi = null;
    }

    handleCellValueChange = (params) => {
        rowsToUpdate.push(
            Validators.prepareRowEdit(
                params.data,
                params.colDef.field,
                this.props.featureFlags,
                true
            )
        );
        if (timerForUpdate) clearInterval(timerForUpdate);
        timerForUpdate = setInterval(() => {
            const length = rowsToUpdate.length;
            if (length > 0) {
                const list = rowsToUpdate.splice(0, length);
                this.props.editData(list);
            } else {
                clearInterval(timerForUpdate);
            }
        }, 20);
    };

    handleGridReady = (params) => {
        this.gridApi = params.api;
    };

    render() {
        const {
            rowData,
            deleteRow,
            startEditingCell,
            stopEditingCell,
            userSettings,
            featureFlags,
        } = this.props;

        const customRenderers = {
            deleteButton: DeleteRenderer,
            customTooltip: TruTooltip,
            datePicker: DatePickerEditor,
        };

        const contextParams = {
            deleteRow,
            preferredCcy: userSettings.preferredCcy,
            featureFlags,
        };

        return (
            <div className={["ag-theme-alpine-dark", styles.table].join(" ")}>
                <AgGridReact
                    enableRangeSelection
                    stopEditingWhenCellsLoseFocus
                    getRowId={(params) => params.data.id}
                    enableFillHandle
                    undoRedoCellEditing
                    undoRedoCellEditingLimit={10}
                    rowBuffer={100}
                    defaultColDef={CommonColumnDefs}
                    columnDefs={getTakeAvailabilityColumnDefs()}
                    rowData={rowData}
                    rowClassRules={RowClassRules}
                    onCellValueChanged={this.handleCellValueChange}
                    tooltipShowDelay={1}
                    components={customRenderers}
                    context={contextParams}
                    onGridReady={this.handleGridReady}
                    onCellEditingStarted={startEditingCell}
                    onCellEditingStopped={stopEditingCell}
                    onSortChanged={(e) => e.api.refreshCells()}
                    rowSelection={"multiple"}
                    defaultCsvExportParams={{ onlySelected: true }}
                    defaultExcelExportParams={{ onlySelected: true }}
                    excelStyles={EXPORT_FORMAT.EXCEL}
                    suppressCopyRowsToClipboard={true}
                    rowHeight={40}
                    headerHeight={40}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    rowData: AvailabilitySelectors.GetRequestRows(state),
    sendingState: TxSelectors.TxInitSendingState(state),
    isReadyToSubmit: TxSelectors.TxInitIsReady(state),
    userSettings: SettingsSelectors.UserSettings(state),
    featureFlags: SettingsSelectors.FeatureFlags(state),
});

const mapDispatchToProps = (dispatch) => ({
    editData: (rows) => dispatch(AvailabilityActions.UpdateTakeRow(rows)),
    deleteRow: (rowId) => dispatch(AvailabilityActions.DeleteRequestRow(rowId)),
    startEditingCell: () => dispatch(TableActions.StartEditingCell()),
    stopEditingCell: () => dispatch(TableActions.StopEditingCell()),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(Table);
